// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--14Rty","innerWrapper":"styles-module--inner-wrapper--2tmaN","heading":"styles-module--heading--2l7fB","subHeading":"styles-module--subHeading--10vuA"};